var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blog-list px-3 py-5 p-md-5"},[_c('ListPost',{attrs:{"is_GraphCMS":_vm.is_GraphCMS}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }